import { createContext } from "react";

const LocaleContext = createContext('bg');

export default LocaleContext;